import { Link } from "react-router-dom";
import { DashboardLayout } from "../../../../Layout/DashboardLayout";
import CustomFilters from "../../../../Components/CustomFilters";
import { useEffect, useState, useCallback } from "react";
import CustomTable from "../../../../Components/CustomTable";
import moment from "moment";
import { Dropdown } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit, faEllipsisV, faTimes } from "@fortawesome/free-solid-svg-icons";
import { deleteRequest, getRequest } from "../../../../Util/requests";
import { errorModal, questionModal, successModal } from "../../../../Components/CustomModal";
import CustomLoader from "../../../../Components/CustomLoader";

const HEADER = [
    { key: "id", title: "S.No" },
    { key: "paragrah", title: "Paragraph" },
    { key: "actions", title: "Actions" },
];

const IndustryParentManagement = () => {
    const [data, setData] = useState([]);
    const [offset, setOffset] = useState(0);
    const [loader, setLoader] = useState(false);
    const [entries, setEntries] = useState(10);
    const [totalCount, setTotalCount] = useState(0);
    const [filterSearchValue, setFilterSearchValue] = useState("");
    const [debouncedSearchValue, setDebouncedSearchValue] = useState("");

    useEffect(() => {
        const timer = setTimeout(() => {
            setDebouncedSearchValue(filterSearchValue);
            setOffset(0);
        }, 2000);

        return () => clearTimeout(timer);
    }, [filterSearchValue]);

    const fetchData = useCallback(async () => {
        try {
            setLoader(true);
            const queryParams = new URLSearchParams({
                limit: entries,
                offset: offset,
                search: debouncedSearchValue
            }).toString();

            const response = await getRequest(`/api/user/industry-parents/?${queryParams}`);

            if (response && !response.data.error) {
                setData(response.data.data || []);
                setTotalCount(response.data.count || 0);
            } else {
                console.error("Fetch error:", response?.data?.message);
            }
        } catch (error) {
            console.error("Request failed:", error);
        } finally {
            setLoader(false);
        }
    }, [entries, offset, debouncedSearchValue]);

    useEffect(() => {
        fetchData();
    }, [fetchData]);

    const handleDelete = async (id) => {
        try {
            setLoader(true);
            const result = await questionModal.fire({
                title: `Do you want to delete this Buying Parent?`,
                confirmButtonText: "Delete",
            });
            if (result.isConfirmed) {
                const response = await deleteRequest(`/api/user/industry-parents/${id}/`);
                if (response && !response.data.error) {
                    successModal.fire({
                        text: "Buying Industry deleted successfully",
                        confirmButtonText: "Continue",
                    });
                    setData(prevData => prevData.filter(item => item.id !== id));
                } else {
                    errorModal.fire({
                        text: "Unable to delete this Buying Industry",
                        confirmButtonText: "Continue",
                    });
                }
            }

        } catch (err) {
            console.error("Delete failed:", err);
        } finally {
            setLoader(false);
        }
    };

    return (
        <DashboardLayout>
            <div className="container-fluid">
                <div className="row mb-3">
                    <div className="col-lg-8 mb-2">
                        <h2 className="mainTitle">Buying Industry</h2>
                    </div>
                    <div className="col-lg-4 text-end mb-2">
                        <Link
                            to="/scofa/buying-industry/add"
                            className="customButton primaryButton"
                        >
                            Add Buying Industry
                        </Link>
                    </div>
                </div>

                <div className="row mb-3">
                    <div className="col-12">
                        <CustomFilters
                            enteries={entries}
                            totalCount={totalCount}
                            entriesFilter={true}
                            setEnteries={(e) => setEntries(e.target.value)}
                            filterSearch={true}
                            filterSearchValue={filterSearchValue}
                            setFilterSearchValue={setFilterSearchValue}
                        />
                    </div>
                </div>

                <div className="row mb-3">
                    <div className="col-12">
                        {loader ? (
                            <CustomLoader />
                        ) : (
                            <CustomTable headers={HEADER}>
                                <tbody>
                                    {data.map((item, index) => (
                                        <tr key={item.id || index}>
                                            <td>{offset + index + 1}</td>
                                            <td style={{ maxWidth: '400px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{item.paragrah || item.paragraph}</td>
                                            <td>
                                                <Dropdown className="tableDropdown">
                                                    <Dropdown.Toggle
                                                        variant="transparent"
                                                        className="notButton classicToggle"
                                                    >
                                                        <FontAwesomeIcon icon={faEllipsisV} />
                                                    </Dropdown.Toggle>
                                                    <Dropdown.Menu align="end" className="tableDropdownMenu">
                                                        <Link
                                                            to={`/scofa/buying-industry/edit/${item.id}`}
                                                            className="dropdown-item"
                                                        >
                                                            <FontAwesomeIcon icon={faEdit} /> Edit
                                                        </Link>
                                                        <Dropdown.Item
                                                            className="dropdown-item"
                                                            onClick={() => handleDelete(item.id)}
                                                        >
                                                            <FontAwesomeIcon icon={faTimes} /> Delete
                                                        </Dropdown.Item>
                                                    </Dropdown.Menu>
                                                </Dropdown>
                                            </td>
                                        </tr>
                                    ))}
                                    {data.length === 0 && (
                                        <tr>
                                            <td colSpan={HEADER.length} className="text-center">No Buying Industry found.</td>
                                        </tr>
                                    )}
                                </tbody>
                            </CustomTable>
                        )}
                    </div>
                </div>
            </div>
        </DashboardLayout>
    );
};

export default IndustryParentManagement;
